import CollectionModule from 'client/store/modules/CollectionModule';
import PasswordManagerUserApi from 'client/api/v2/PasswordManagerUserApi';
import Vue from 'vue';

export const PasswordManagerUserCollection = (Api = PasswordManagerUserApi) => {
  const collection = new CollectionModule(Api, 'id', 'name');
  const PasswordManagerUserCollectionModule = collection.extractModule();

  const getInitialState = () => {
    const { state } = PasswordManagerUserCollectionModule;
    state.refreshKey = 0;
    state.sentInvitationEmails = {};
    return state;
  };

  return {
    namespaced: true,

    state: getInitialState(),

    actions: {
      ...PasswordManagerUserCollectionModule.actions,

      async resendInvitation(context, userIds) {
        await Api.resendInvitation(userIds);
        const sentInvitationEmails = { ...context.state.sentInvitationEmails };
        userIds.forEach(userId => {
          sentInvitationEmails[userId] = userId;
        });

        context.commit('UPDATE_SENT_INVITATION_EMAILS', sentInvitationEmails);
      },

      updateRefreshKey(context) {
        context.commit('UPDATE_REFRESH_KEY');
      },

      /*
        overrides CollectionModule resetCollection action
      */
      resetCollection(context, { soft = false, preserveTotalCount = undefined } = {}) {
        context.commit('RESET_COLLECTION', { soft, preserveTotalCount });
        if (!soft) { context.commit('UPDATE_SENT_INVITATION_EMAILS', {}); }
      },
    },

    getters: {
      ...PasswordManagerUserCollectionModule.getters,

      refreshKey(state) {
        return state.refreshKey;
      },

      sentInvitationEmails(state) {
        return state.sentInvitationEmails;
      },
    },

    mutations: {
      ...PasswordManagerUserCollectionModule.mutations,

      UPDATE_REFRESH_KEY(state) {
        Vue.set(state, 'refreshKey', state.refreshKey + 1);
      },

      UPDATE_SENT_INVITATION_EMAILS(state, sentInvitationEmails) {
        Vue.set(state, 'sentInvitationEmails', sentInvitationEmails);
      },
    },
  };
};

export default PasswordManagerUserCollection();
